// @flow
import React from 'react';

export type Props = {
  value: string,
  type: string,
  callback: (...args: Array<any>) => any
};

const TimeSelect = (props: Props) => {
  const { value, type, callback } = props;
  const hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
  const time = value.split(':');
  return (
    <div className="c-datepicker__time">
      <span className="icon icon-clock" />
      <div className="c-datepicker__hour">
        <select
          value={time[0]}
          onChange={e => {
            callback.apply(this, [type.toLowerCase(), 'hour', e.target.value]);
          }}
        >
          <option key={0} value={24}>
            00&nbsp;&nbsp;&nbsp;&nbsp;(midnight)
          </option>
          {hours.map((val, idx) => (
            <option key={idx} value={val}>
              {(num => `${1e15 + num}`.slice(-2))(val)}
            </option>
          ))}
          <option key={12} value={12}>
            12&nbsp;&nbsp;&nbsp;&nbsp;(noon)
          </option>
          {hours.map((val, idx) => (
            <option key={idx} value={val + 12}>
              {val + 12}
            </option>
          ))}
        </select>
      </div>
      <div className="c-datepicker__minute">
        <select
          value={parseInt(time[1], 10)}
          onChange={e => {
            callback.apply(this, [
              type.toLowerCase(),
              'minute',
              e.target.value
            ]);
          }}
        >
          {minutes.map((val, idx) => (
            // return value with leading 0 if needed ('0' => '00')
            <option key={idx} value={val}>
              {(num => `${1e15 + num}`.slice(-2))(val)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default TimeSelect;
